import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ConnectWalletBtn from "../components/ConnectWalletBtn";
import Line from "../components/Line";
import { images } from "../shared/images";
import { ethers } from "ethers";
import { CONSTANTS } from "../shared/constants";
import nfmStakingAbi from "../shared/blockchain/nfmStakingAbi.json";
import { Network, Alchemy } from "alchemy-sdk";
import axios from "axios";
import { nftUrl } from "../shared/config";

const Staking = () => {
	const [isWalletConnected, setIsWalletConnected] = useState(false);
	const [walletAddress, setWalletAddress] = useState("");
	const [network, setNetwork] = useState(0);
	const [NFMs, setNFMs] = useState([]);
	const [stakedNFMs, setStakedNFMs] = useState([]);

	useEffect(() => {
		const fetchData = async () => {
			let wallet_connection = localStorage.getItem("wallet_connection");
			let wallet_address = localStorage.getItem("wallet_address");
			let chain_id = localStorage.getItem("chain_id");
			setIsWalletConnected(wallet_connection);
			setWalletAddress(wallet_address);
			setNetwork(chain_id);

			if (wallet_connection === true || wallet_connection === "true") {
				const provider = new ethers.providers.Web3Provider(window.ethereum);
				const signer = provider.getSigner();
				const address = await signer.getAddress();
				let selectedNetwork = null;

				if(CONSTANTS.STAKE_NETWORK_ID == 5) {
					selectedNetwork = Network.ETH_GOERLI;
				} else if (CONSTANTS.STAKE_NETWORK_ID == 1) {
					selectedNetwork = Network.ETH_MAINNET;
				}

				const settings = {
					apiKey: CONSTANTS.ALCHEMY_KEY,
					network: selectedNetwork,
				};

				const alchemy = new Alchemy(settings);

				// get user profiles
				const nfms = await alchemy.nft.getNftsForOwner(address);
				if (nfms.ownedNfts != undefined) {
					setNFMs(nfms.ownedNfts);
				}

				// get staked profile
				const nfmStaking = new ethers.Contract(
					CONSTANTS.NFM_STAKING_CONTRACT,
					nfmStakingAbi,
					signer
				);
				const nfmsStaked = await nfmStaking.getNoOfNFMsStakedByCollectionByUser(
					address,
					CONSTANTS.NFM_CONTRACT
				);

				if (nfmsStaked.length > 0) {
					let nfmsStakedList = [];
					for (let i = 0; i < nfmsStaked.length; i++) {
						const response = await axios.get(
							`${nftUrl}/nft/metadata/${nfmsStaked[i]}`
						);
						nfmsStakedList.push(response.data);
						// console.log(nfmsStakedList, "nfmsStakedList");
					}
					setStakedNFMs(nfmsStakedList);
					// console.log(stakedNFMs, "stakedNFMs");
				}
			}
		};

		fetchData();
	}, [setIsWalletConnected, setWalletAddress, setNetwork, setNFMs]);

	return (
		<div className="staking">
			<div className="staking__banner">
				<img src={images.stakingBanner} alt="Staking Banner" />
			</div>

			{/* Staking  */}
			<div className="staking__page">
				<h1 className="heading-primary-4 mt-4 text-center">Time To Stake</h1>
				{/* Connect Wallet Button */}
				<ConnectWalletBtn source="stake" />

				{/* <h1 className="heading-primary-4 mt-4 text-center">BOT COLLECTIONS</h1> */}

				{!isWalletConnected && (
					<p className="text-center text-white mt-s mb-small">
						Connect wallet to check your Nitro bots{" "}
					</p>
				)}

				{isWalletConnected && (
					<>
						<Line />
						<h2 className="heading-primary-4 sm-font mt-4 text-center">
							My Nitro Bot Collections
						</h2>
						{/* NFT's To stake : After Connect Wallet */}
						<div className="staking__nfts">
							{NFMs.map((nfm, index) => (
								<Link
									to={`/nft/${nfm.tokenId}`}
									className="staking__nft"
									key={index}
								>
									<div className="staking__nft--image">
										<img
											src={nfm.rawMetadata.image}
											alt={nfm.rawMetadata.title}
										/>
									</div>
									<button className="btn btn-white">Stake</button>
								</Link>
							))}
						</div>

						{/* If Staked NFM : After Connect Wallet */}
						<h1 className="heading-primary-3 mt-4 text-center">Staked</h1>

						{stakedNFMs.length > 0 && (
							<div className="staking__nfts">
								{stakedNFMs.map((nfm, index) => (
									<Link to={`/nft/${nfm.edition}`} key={index}>
										<div className="staking__nft staked__nft">
											{/* NFT Image */}
											<div className="staking__nft--image">
												<img src={nfm.image} alt="Nft 1" />
											</div>
											{/* Black Layer */}
											<div className="staking__nft--staked"></div>
											{/* Staked Stamp */}
											<img
												src={images.staked}
												alt="Staked Stamp"
												className="staking__nft--stake-img"
											/>
										</div>
									</Link>
								))}
							</div>
						)}

						{stakedNFMs.length == 0 && (
							<p className="text-white mb-small text-center">
								Nothing staked yet
							</p>
						)}
					</>
				)}
			</div>
		</div>
	);
};

export default Staking;
